var React = require('react');

function Visualstudiocode (props) {
    return React.createElement("svg",props,[React.createElement("title",{"id":"simpleicons-visualstudiocode-icon","key":0},"Visual Studio Code icon"),React.createElement("path",{"d":"M24 2.5v19L18 24 0 18.5v-.561l18 1.545V0zM1 13.111L4.385 10 1 6.889l1.418-.827L5.853 8.65 12 3l3 1.456v11.088L12 17l-6.147-5.65-3.434 2.589zM7.644 10L12 13.283V6.717z","key":1})]);
}

Visualstudiocode.displayName = "Visualstudiocode";

Visualstudiocode.defaultProps = {"aria-labelledby":"simpleicons-visualstudiocode-icon","role":"img","viewBox":"0 0 24 24"};

module.exports = Visualstudiocode;

Visualstudiocode.default = Visualstudiocode;



//////////////////
// WEBPACK FOOTER
// ./src/images/inline-svg/visualstudiocode.svg
// module id = 895
// module chunks = 35783957827783